import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject, debounceTime, map } from 'rxjs';
import { AppConfigService } from '../../configs';

@Injectable({
  providedIn: 'root'
})
export class DocumentService {
  private readonly documentContentSubject: Subject<string> = new Subject<string>(); 
  private currentObjectUrl: string = '';

  constructor(private readonly configs: AppConfigService, private readonly http: HttpClient) { }

  getDocumentContentsAsBase64(documentId: string, projectId: string): Observable<string> {
    return this.retrieveDocument(documentId, projectId);
  }
  getDocumentText(documentId: string, projectId: string): Observable<string> {
    return this.http.get<string>(`${this.configs.get().apiUrl}/projects/${projectId}/documents/${documentId}/text`)
    .pipe(map((_: any) => {
      return _.data;
    }));
  }
  private retrieveDocument(documentId: string, projectId: string) {
    return this.http.get(`${this.configs.get().apiUrl}/projects/${projectId}/documents/${documentId}/file`)
    .pipe(debounceTime(900))
    .pipe(map((_: any) => {
      var pdfStream = _.data;
      this.currentObjectUrl = window.URL.createObjectURL(this.b64toBlob(pdfStream, 'application/pdf'));
      return this.currentObjectUrl;
    }));
  }
  private b64toBlob (b64Data: string, contentType='', sliceSize=512) {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
  
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
  
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
  
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
      
    const blob = new Blob(byteArrays, {type: contentType});
    return blob;
  }
}
